import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { createRoot } from 'react-dom/client';
import App from './component/App';

const initializeApp = async () => {
  const version_response = await fetch(`/version.json?t=${new Date().getTime()}`);
  const app_config = await version_response.json();
  window['app_config'] = app_config.config;

  if (app_config.config.env === 'local') {
    console.log('App config:', app_config.config);
  }

  const env = window['app_config'].env;

  datadogLogs.setGlobalContext({ env });
  datadogLogs.logger.setHandler(['http', 'console']);

  // Build allowedTracingUrls from the runtime config. The api_host_name is the API Gateway
  // base URL (e.g. https://5fqn3fbfhf.execute-api.us-east-2.amazonaws.com/dev). We match
  // any URL starting with this origin so traceparent/tracestate/baggage headers are injected
  // on all GraphQL and REST requests to the backend.
  const apiHost = window['app_config'].api_host_name || '';
  const tracingUrls = apiHost
    ? [{ match: apiHost, propagatorTypes: ['tracecontext' as const, 'datadog' as const] }]
    : [];

  if (env === 'dev') {
    datadogLogs.init({
      clientToken: 'pub954529ab8b5174d86040a6b168a724cf',
      site: 'datadoghq.com',
      service: 'amber-dev-customer-dashboard',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
    });

    datadogRum.init({
      applicationId: 'b18d62ef-fd59-424f-a94a-d1d0a511577a',
      clientToken: 'pub954529ab8b5174d86040a6b168a724cf',
      site: 'datadoghq.com',
      service: 'amber-dev-customer-dashboard',
      env: 'dev',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      // Distributed tracing: inject W3C traceparent + Datadog headers on requests to our API.
      // Requires 'traceparent', 'tracestate', 'baggage' in API Gateway CORS Access-Control-Allow-Headers.
      allowedTracingUrls: tracingUrls,
      traceSampleRate: 100,
      traceContextInjection: 'sampled',
      propagateTraceBaggage: true,
    });
  } else if (env === 'prod') {
    datadogLogs.init({
      clientToken: 'pub954529ab8b5174d86040a6b168a724cf',
      service: 'amber-prod-customer-dashboard',
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
    });
    datadogRum.init({
      applicationId: '9641def9-dec7-4325-a923-c12e375c7253',
      clientToken: 'pub7a48f9325ccb59a42e9a57f367a062a6',
      site: 'datadoghq.com',
      service: 'amber-prod-customer-dashboard',
      env: 'prod',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'allow',
      // Distributed tracing: inject W3C traceparent + Datadog headers on requests to our API.
      // Requires 'traceparent', 'tracestate', 'baggage' in API Gateway CORS Access-Control-Allow-Headers.
      allowedTracingUrls: tracingUrls,
      traceSampleRate: 100,
      traceContextInjection: 'sampled',
      propagateTraceBaggage: true,
    });
  }

  const rootElement = document.getElementById('app') ?? document.createElement('div');
  const root = createRoot(rootElement);
  root.render(<App />);
};

void initializeApp().then(() => {
  console.log('The Amber Ag Dashboard Application has loaded.');
});
